(() => {
  const initSlider = (section) => {
    let parent;
    if (document.currentScript) {
      parent = document.currentScript.parentElement;
    } else {
      parent = section;
    }

    const slider = parent?.querySelector('.promotional-banner__slider');

    if (slider) {
      const speed = parseInt(slider.dataset.speed) || 5000;
      const isAutoplay = slider.dataset.autoplay === 'true';
      const isLoop = slider.dataset.loop === 'true';

      const swiperParams = {
        slidesPerView: 1,
        speed: 500,
        allowTouchMove: true,
      };

      if (isLoop) {
        swiperParams.loop = true;
      }

      if (isAutoplay) {
        swiperParams.autoplay = {
          delay: speed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      new Swiper(slider, swiperParams);
    }
  };

  initSlider();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-promotional-banner')) {
      initSlider(event.target);
    }
  });
})();
